import useGetOrdersTableConfig from './useGetOrdersTableConfig'

export default useGetOrdersTableConfig
